<template>
  <BaseCustomizeMetal componentCode="AS" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAS",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  img {
    // 因葫蘆的形狀是垂直的，以高 100% 為標準撐開
    width: auto !important;
    height: 100%;
  }
  .metal-text {
    top: 202px;
    left: 170px;
    @include betweenTableTablePro {
      transform: scale(0.8);
      top: 150px;
      left: 121px;
    }
    @include table {
      transform: scale(0.7);
      top: 123px;
      left: 97px;
    }
    @include phone {
      transform: scale(0.64);
      top: 106px;
      left: 80px;
    }
  }
  .templeName {
    height: 22px;
    width: 143px;
    .textContainer {
      width: 143px;
    }
  }
  .godName {
    width: 159px;
    height: 50px;
    .textContainer {
      width: 159px;
    }
  }
  .gift {
    width: 110px;
    height: 33px;
    .textContainer {
      width: 110px;
    }
  }
}
</style>
